import request from '@/utils/request'

export function getMyFiles(payload = {}) {
  if(payload instanceof FormData)
    payload.append('_method', 'GET');
  else
    payload._method = 'GET';

  return request({
    url: "chat/files/my",
    method: 'post',
    data: payload
  })
}

export function getMyFolders(payload = {}) {
  if(payload instanceof FormData)
    payload.append('_method', 'GET');
  else
    payload._method = 'GET';

  return request({
    url: "chat/files/folders",
    method: 'post',
    data: payload
  })
}

export function updateDeliveredStatus(chat_head_id, chat_head_message_id) {
  return request({
    url: `chat/${chat_head_id}/${chat_head_message_id}/delivery-status`,
    method: 'patch',
  })
}

export function updateSeenStatus(data) {
  return request({
    url: 'chat-message/seen',
    method: 'post',
    data
  })
}

export function removeMessage(chat_head_id, chat_head_message_id) {
  return request({
    url: `chat/${chat_head_id}/${chat_head_message_id}`,
    method: 'delete',
  })
}

export function removeMultipleMessages(input)  {
  return request({
    url: `chat/delete-multiple`,
    method: 'delete',
    data: input
  })
}

export function setMessageReaction(input, deletion = false)  {
  return request({
    url: `chat/reaction`,
    method: deletion ? 'delete' : 'post',
    data: input
  })
}

/**
 * get chat message
 * @param {*} param0
 * @param {*} data
 */
export function getChatMessages(data) {
  return request({
    url: 'get-all-chat-messages',
    method: 'post',
    data
  })
}

export function getIndividualChatMessages(data) {
  return request({
    url: 'chat-messages',
    method: 'post',
    data
  })
}

export function getChatAndContact(params = {}) {
  params._method = 'GET';
  return request({
    url: 'get-chat-contact-list',
    method: 'POST',
    data: params
  })
}


export function chatForwardMessages(input = {}) {
  return request({
    url: 'chat/forward',
    method: 'POST',
    data: input
  })
}
